// ─── AI ───────────────────────────────────────────────────────────────────────

export function prepareTitleIAData(proposal) {
  const form_data = new FormData();
  form_data.append('user_network_uuid', proposal.user_network.uuid);
  form_data.append('category', proposal.work_type);
  form_data.append('sub_category', proposal.content_type);
  form_data.append('proposal_uuid', proposal.uuid);
  return form_data;
}

export function prepareDescriptionIAData(uuid, type_description, title, length) {
  const form_data = new FormData();
  form_data.append('type_description', type_description);
  form_data.append('title', title);
  form_data.append('length', length);
  form_data.append('uuid', uuid);
  return form_data;
}

export function checkFieldsNeedingIA(proposal) {
  return {
    needsTitle: proposal.title.length === 0,
    needsDescription: proposal.description.length === 0,
    needsDealDescription: proposal.deals.length > 0,
    needsImages: proposal.images.length === 0 && proposal.user_network.network === 'instagram'
  };
}

// ─── Media ────────────────────────────────────────────────────────────────────

export function getInstagramMediaUrl(content) {
  return `https://klear.com/api/2.1/HostedContent/instagram_post?url=https://www.instagram.com/p/${content.basic.code}/`;
}

export function getFirstMediaItems(media, limit = 10) {
  const results = Object.values(media);
  return results ? results.slice(0, limit) : [];
}

export function prepareImagesFormData(mediaItems, getMediaContentsFn) {
  const form_data = new FormData();
  mediaItems.forEach((content) => {
    form_data.append('images_string', getMediaContentsFn(content));
  });
  return form_data;
}
